/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Sandbox140 = (props: SVGProps) => (
    <AccessibleSVG width={140} height={140} viewBox="0 0 140 140" {...props}>
        <g fill="none" fillRule="evenodd" transform="translate(0 7)">
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M13 118.5s29 1.5 57 1.5 34-4 46-4 12 4 12 4l-1 5H14l-1-6.5z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                d="M134.83 28H89a1 1 0 010-2h29.83a4.12 4.12 0 004.17-3.61 4 4 0 00-4-4.39H23.17A4.12 4.12 0 0019 21.61 4 4 0 0023 26h55a1 1 0 010 2H39.17A4.12 4.12 0 0035 31.61 4 4 0 0039 36h15a2 2 0 110 4H5.17A4.12 4.12 0 001 43.61 4 4 0 005 48h94.83a4.12 4.12 0 004.17-3.61 4 4 0 00-4-4.39H72a2 2 0 110-4h63a4 4 0 004-4.39 4.12 4.12 0 00-4.17-3.61z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M110.86 76l17.64 30h-117l17.64-30h81.72zm.57-2H28.57a1 1 0 00-.86.49L8 108h124l-19.71-33.51a1 1 0 00-.86-.49z"
            />
            <path
                fill={vars.white}
                fillRule="nonzero"
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M78.09 82.78C63 79.24 58.18 63.48 39.36 73.19c-11.44 5.9-16 19-22.36 29.81h106"
            />
            <path
                stroke={vars.bdlBoxBlue}
                strokeLinecap="square"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 109v3h122v-3"
            />
            <path
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M128 112l-1 13H14l-1-13"
            />
            <path
                fill={vars.bdlBoxBlue}
                d="M73.51 55.52v-.41a.32.32 0 01.63 0v.41a.63.63 0 01.23.23h.4a.31.31 0 01.31.31.31.31 0 01-.31.32h-.4a.84.84 0 01-.23.23V57a.32.32 0 01-.63 0v-.39a.63.63 0 01-.23-.23h-.41a.32.32 0 01-.31-.32.31.31 0 01.31-.31h.41c.05-.1.13-.18.23-.23zm20-54v-.41a.32.32 0 01.63 0v.41a.63.63 0 01.23.23h.4a.31.31 0 01.31.31.31.31 0 01-.31.32h-.4a.84.84 0 01-.23.23V3a.32.32 0 11-.63 0v-.39a.63.63 0 01-.23-.23h-.41a.32.32 0 01-.31-.32.31.31 0 01.31-.31h.41c.05-.1.13-.18.23-.23zm35 70v-.41a.32.32 0 01.63 0v.41a.63.63 0 01.23.23h.4a.31.31 0 01.31.31.31.31 0 01-.31.32h-.4a.84.84 0 01-.23.23V73a.32.32 0 11-.63 0v-.39a.63.63 0 01-.23-.23h-.41a.32.32 0 01-.31-.32.31.31 0 01.31-.31h.41c.05-.1.13-.18.23-.23zm-111-65v-.41a.32.32 0 01.63 0v.41a.63.63 0 01.23.23h.4a.31.31 0 01.31.31.31.31 0 01-.31.32h-.4a.84.84 0 01-.23.23V8a.32.32 0 01-.63 0v-.39a.63.63 0 01-.23-.23h-.41a.32.32 0 01-.31-.32.31.31 0 01.31-.31h.41c.05-.1.13-.18.23-.23zM9.29 64v-.4a.32.32 0 01.32-.31.31.31 0 01.31.31v.4a.63.63 0 01.23.23h.41a.32.32 0 01.31.32.31.31 0 01-.31.31h-.41a.51.51 0 01-.23.23v.41a.31.31 0 01-.31.31.32.32 0 01-.32-.32v-.4a.63.63 0 01-.23-.23h-.4a.32.32 0 010-.63h.4a.84.84 0 01.23-.23zm24.64-11.18v-.65a.51.51 0 011 0v.65a1 1 0 01.37.36h.7a.51.51 0 01.5.51.5.5 0 01-.5.5h-.64a1.09 1.09 0 01-.37.37v.65a.51.51 0 01-1 0v-.63a1.09 1.09 0 01-.37-.37h-.65a.51.51 0 010-1h.65a1 1 0 01.31-.39zM6.29 17v-.4a.32.32 0 01.32-.31.31.31 0 01.31.31v.4a.63.63 0 01.23.23h.41a.32.32 0 01.31.32.31.31 0 01-.31.31h-.41a.51.51 0 01-.23.23v.41a.31.31 0 01-.31.31.32.32 0 01-.32-.32v-.4a.63.63 0 01-.23-.23h-.4a.32.32 0 010-.63h.4a.84.84 0 01.23-.23zm125.1-4.72v-.65a.51.51 0 01.51-.49.49.49 0 01.5.49v.65a1 1 0 01.37.37h.65a.5.5 0 01.49.5.49.49 0 01-.49.5h-.65a1 1 0 01-.37.37v.65a.5.5 0 01-.5.49.51.51 0 01-.51-.5V14a1 1 0 01-.37-.37h-.64a.5.5 0 010-1h.62a1 1 0 01.39-.35zm-16.68 35.85v-.63a.5.5 0 01.5-.5.49.49 0 01.5.49v.65a1 1 0 01.37.36h.64a.51.51 0 010 1h-.64a1 1 0 01-.37.37v.65a.5.5 0 01-1 0v-.64a1 1 0 01-.38-.37h-.65a.51.51 0 01-.49-.51.49.49 0 01.49-.5h.66a1 1 0 01.37-.37zM61.67 11.14v-.64a.51.51 0 011 0v.65a1 1 0 01.36.37h.65a.51.51 0 010 1H63a1 1 0 01-.36.37v.64a.51.51 0 01-.51.5.5.5 0 01-.5-.51v-.63a1.09 1.09 0 01-.37-.37h-.65a.51.51 0 01-.49-.51.49.49 0 01.49-.5h.65a1.09 1.09 0 01.41-.37z"
            />
            <path
                fill={vars.white}
                fillRule="nonzero"
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M106 71l-2.4 22.5c0 1.66-4.29 3-9.6 3s-9.6-1.34-9.6-3L82 71"
            />
            <path
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M85.93 78.38c4 8.1 24.93 15.06 19.13 1.32"
            />
            <ellipse
                cx={94}
                cy={70.5}
                fill={vars.white}
                fillRule="nonzero"
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                rx={12}
                ry={3.5}
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M53.09 75.55a39.05 39.05 0 000 11.73L56 86l-2.91-10.45z"
            />
            <path
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M44.92 90.89L43 81.08l-.32-1.67a2 2 0 01.88-2.08 12.46 12.46 0 019.28-1.83 2 2 0 011.61 1.59l.33 1.66L56 86l-11.08 4.89zM48 75.5l-2.03-10.3L48 75.5zm-2-10.3l-4.11-5.3a1 1 0 01.6-1.6l4.13-.81a1 1 0 011.16 1.25L46 65.2zm-2.54 26.64s-1.84-7.12-.84-13.12l.84 13.12z"
            />
            <path
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M34 95c9.11-.79 16.85-7.89 25-8.67 10.51-1 12.69 4.59 21 6.67"
            />
            <path
                fill={vars.white}
                fillRule="nonzero"
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M123 103l-14-24"
            />
        </g>
    </AccessibleSVG>
);

export default Sandbox140;
